var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "master-material-form" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { staticClass: "fa fa-align-justify" }),
                      _vm._v(" "),
                      _vm.item.id == ""
                        ? _c("strong", [_vm._v(_vm._s(_vm.$t("create")))])
                        : _c("strong", [_vm._v(_vm._s(_vm.$t("edit")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _vm.item.id != null
                      ? _c(
                          "b-form",
                          { staticClass: "row" },
                          [
                            _c(
                              "b-col",
                              { attrs: { "align-self": "center" } },
                              [
                                _c(
                                  "b-form-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t("code"),
                                              "label-cols": 2,
                                              horizontal: true
                                            }
                                          },
                                          [
                                            _c("b-form-input", {
                                              staticClass: "form-control",
                                              model: {
                                                value: _vm.item.code,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.item,
                                                    "code",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.code"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t("name"),
                                              "label-cols": 2,
                                              horizontal: true
                                            }
                                          },
                                          [
                                            _c("b-form-input", {
                                              staticClass: "form-control",
                                              model: {
                                                value: _vm.item.name,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.item,
                                                    "name",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.name"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t("uom_name"),
                                              "label-cols": 2,
                                              horizontal: true
                                            }
                                          },
                                          [
                                            _c("v-select", {
                                              attrs: { options: _vm.uoms },
                                              model: {
                                                value: _vm.item.uom_id,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.item,
                                                    "uom_id",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.uom_id"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t("plucode"),
                                              "label-cols": 2,
                                              horizontal: true
                                            }
                                          },
                                          [
                                            _c("b-form-input", {
                                              staticClass: "form-control",
                                              model: {
                                                value: _vm.item.plucode,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.item,
                                                    "plucode",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.plucode"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t("sku"),
                                              "label-cols": 2,
                                              horizontal: true
                                            }
                                          },
                                          [
                                            _c("b-form-input", {
                                              staticClass: "form-control",
                                              attrs: {
                                                placeholder:
                                                  "Ie. 224300006,213830015,213830014"
                                              },
                                              model: {
                                                value: _vm.item.sku,
                                                callback: function($$v) {
                                                  _vm.$set(_vm.item, "sku", $$v)
                                                },
                                                expression: "item.sku"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t("usage"),
                                              "label-cols": 2,
                                              horizontal: true
                                            }
                                          },
                                          [
                                            _c("b-form-input", {
                                              staticClass: "form-control",
                                              model: {
                                                value: _vm.item.usage,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.item,
                                                    "usage",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.usage"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t("expired_in"),
                                              "label-cols": 2,
                                              horizontal: true
                                            }
                                          },
                                          [
                                            _c("b-form-input", {
                                              staticClass: "form-control",
                                              model: {
                                                value: _vm.item.expired_in,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.item,
                                                    "expired_in",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.expired_in"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t("price"),
                                              "label-cols": 2,
                                              horizontal: true
                                            }
                                          },
                                          [
                                            _c("b-form-input", {
                                              staticClass: "form-control",
                                              attrs: { disabled: "" },
                                              model: {
                                                value: _vm.item.price,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.item,
                                                    "price",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.price"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t("active"),
                                              "label-cols": "2",
                                              horizontal: true
                                            }
                                          },
                                          [
                                            _c(
                                              "c-switch",
                                              _vm._b(
                                                {
                                                  attrs: {
                                                    type: "icon",
                                                    variant: "primary",
                                                    checked: _vm.item.is_active,
                                                    value: 1,
                                                    uncheckedValue: 0
                                                  },
                                                  model: {
                                                    value: _vm.item.is_active,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.item,
                                                        "is_active",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "item.is_active"
                                                  }
                                                },
                                                "c-switch",
                                                { on: "\uf00c", off: "\uf00d" },
                                                false
                                              )
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t("daily_batch"),
                                              "label-cols": "2",
                                              horizontal: true
                                            }
                                          },
                                          [
                                            _c(
                                              "c-switch",
                                              _vm._b(
                                                {
                                                  attrs: {
                                                    type: "icon",
                                                    variant: "primary",
                                                    checked:
                                                      _vm.item.is_daily_batch,
                                                    value: 1,
                                                    uncheckedValue: 0
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.item.is_daily_batch,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.item,
                                                        "is_daily_batch",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.is_daily_batch"
                                                  }
                                                },
                                                "c-switch",
                                                { on: "\uf00c", off: "\uf00d" },
                                                false
                                              )
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                disabled:
                                  !_vm.item.code || this.recipes.length === 0
                              },
                              on: { click: _vm.addNew }
                            },
                            [
                              _vm._v(
                                "\n                  Add new\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-modal",
                            {
                              ref: "my-modal",
                              attrs: {
                                id: "modalPrevent",
                                title: "Add recipe detail"
                              },
                              on: { ok: _vm.handleAdd }
                            },
                            [
                              _c(
                                "form",
                                {
                                  attrs: { id: "add-recipe-detail" },
                                  on: {
                                    submit: function($event) {
                                      $event.stopPropagation()
                                      $event.preventDefault()
                                      _vm.hideModal($event)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "b-form-group",
                                    [
                                      _c(
                                        "b-form-radio-group",
                                        {
                                          attrs: {
                                            id: "choose-method",
                                            name: "radioSubComponent"
                                          },
                                          model: {
                                            value: _vm.selected,
                                            callback: function($$v) {
                                              _vm.selected = $$v
                                            },
                                            expression: "selected"
                                          }
                                        },
                                        [
                                          _c(
                                            "b-form-radio",
                                            {
                                              attrs: { value: "true" },
                                              on: {
                                                change: function($event) {
                                                  _vm.switchTab(true)
                                                }
                                              }
                                            },
                                            [_vm._v("Using material")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-radio",
                                            {
                                              attrs: { value: "false" },
                                              on: {
                                                change: function($event) {
                                                  _vm.switchTab(false)
                                                }
                                              }
                                            },
                                            [_vm._v("Using others recipe")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.isHidden
                                    ? _c(
                                        "b-form",
                                        { attrs: { id: "using-material" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: _vm.$t("material"),
                                                "label-cols": 3,
                                                horizontal: true
                                              }
                                            },
                                            [
                                              _c("v-select", {
                                                attrs: {
                                                  options: _vm.materials
                                                },
                                                model: {
                                                  value: _vm.popup.material,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.popup,
                                                      "material",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "popup.material"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.isHidden
                                    ? _c(
                                        "b-form",
                                        {
                                          attrs: { id: "using-others-recipe" }
                                        },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: _vm.$t("recipe"),
                                                "label-cols": 3,
                                                horizontal: true
                                              }
                                            },
                                            [
                                              _c("v-select", {
                                                attrs: { options: _vm.recipes },
                                                model: {
                                                  value: _vm.popup.recipe,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.popup,
                                                      "recipe",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "popup.recipe"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: _vm.$t("recipe_detail_usage"),
                                        "label-cols": 3,
                                        horizontal: true
                                      }
                                    },
                                    [
                                      _c("b-form-input", {
                                        staticClass: "form-control",
                                        model: {
                                          value: _vm.popup.recipe_detail_usage,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.popup,
                                              "recipe_detail_usage",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "popup.recipe_detail_usage"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: _vm.$t("recipe_detail_status"),
                                        "label-cols": "3",
                                        horizontal: true
                                      }
                                    },
                                    [
                                      _c(
                                        "c-switch",
                                        _vm._b(
                                          {
                                            attrs: {
                                              type: "icon",
                                              variant: "primary",
                                              value: 1,
                                              uncheckedValue: 0
                                            },
                                            model: {
                                              value:
                                                _vm.popup.recipe_detail_status,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.popup,
                                                  "recipe_detail_status",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "popup.recipe_detail_status"
                                            }
                                          },
                                          "c-switch",
                                          { on: "\uf00c", off: "\uf00d" },
                                          false
                                        )
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row" },
                      [
                        [
                          _c("b-table", {
                            ref: "table",
                            attrs: {
                              items: _vm.data_table,
                              fields: _vm.columns_table
                            },
                            scopedSlots: _vm._u([
                              _vm._l(_vm.formatted, function(field, fieldKey) {
                                return {
                                  key: field,
                                  fn: function(row) {
                                    return [
                                      _c(
                                        "button",
                                        {
                                          key: fieldKey + "-Edit",
                                          staticClass: "btn btn-sm btn-primary",
                                          on: {
                                            click: function($event) {
                                              _vm.editRecipeDeTail(
                                                row.index,
                                                row.item
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Edit")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          key: fieldKey + "-Remove",
                                          staticClass: "btn btn-sm btn-danger",
                                          on: {
                                            click: function($event) {
                                              _vm.removeRecipeDeTail(row.index)
                                            }
                                          }
                                        },
                                        [_vm._v("Remove")]
                                      )
                                    ]
                                  }
                                }
                              })
                            ])
                          })
                        ]
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-center",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: _vm.model } } },
                          [
                            _c("b-button", { attrs: { variant: "default" } }, [
                              _c("i", { staticClass: "fa fa-arrow-left" }),
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("back")) +
                                  "\n                "
                              )
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.id != null
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.updateItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("update")) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.id == null
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.createItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("save")) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  2
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36f5fed5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36f5fed5","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/inventory/master_recipe/Form.vue
// module id = 1237
// module chunks = 0